import React from 'react';

import Shimmer from './Shimmer';
import { SkeletonStyled } from './Skeleton.styled';

type Props = {
  width?: string;
  maxWidth?: string;
  height?: string;
  borderRadius?: string;
};

const Skeleton = ({ width, maxWidth, height, borderRadius }: Props): JSX.Element => (
  <SkeletonStyled
    maxWidth={maxWidth}
    width={width}
    height={height}
    borderRadius={borderRadius}
    title="Loading..."
  >
    <Shimmer />
  </SkeletonStyled>
);

export default Skeleton;
